const axios = require("axios");

export const getToken = () => {
  if (localStorage.getItem("keptLogged") == "true") {
    return localStorage.getItem("token") || null;
  }
  return sessionStorage.getItem("token") || null;
};

export const getAllEventDefinations = async (limit, offSet, searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
      `eventDefinitions?limit=${limit}&offset=${offSet}&search=${searchText}`
      : process.env.REACT_APP_API_BASE_URL +
      `eventDefinitions?limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getEventDefinationsCount = async (searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
      `eventDefinitions/count?search=${searchText}`
      : process.env.REACT_APP_API_BASE_URL + `eventDefinitions/count`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const putEventDefinationData = async (id, data) => {
  const response = await axios({
    method: "put",
    url: process.env.REACT_APP_API_BASE_URL + `eventDefinitions/` + id,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const getAllWebpageTrigger = async (limit, offSet, searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
      `webpageTriggers?limit=${limit}&offset=${offSet}&search=${searchText}`
      : process.env.REACT_APP_API_BASE_URL +
      `webpageTriggers?limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllWebpageTriggerNoLimit = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `webpageTriggers?type=custom`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getWebpageTriggersCount = async (searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
      `webpageTriggers/count?search=${searchText}`
      : process.env.REACT_APP_API_BASE_URL + `webpageTriggers/count`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getWebpageTriggersInfo = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `webpageTriggers/${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getEventDefinationById = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `eventDefinitions/${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getEventDefinationSchemaById = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `eventDefinitions/${id}/schema`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getEventDefinationSchemaKeyById = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `events/schemaKey?eventDefinitionId=${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getEventDefinationScriptById = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `events/script?eventDefinitionId=${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getWebpageTriggersFilters = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `webpageTriggerFilters`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getWebpageTriggersFiltersByType = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `webpageTriggerFilters?webpageTriggerTypeId=${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getWebpageTriggersTypes = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `webpageTriggerTypes`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const postEventDefinations = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `eventDefinitions`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const putWebpageTriggerData = async (id, data) => {
  const response = await axios({
    method: "put",
    url: process.env.REACT_APP_API_BASE_URL + `webpageTriggers/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const postWebpageTrigger = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `webpageTriggers`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const getEventsById = async (id, limit, offSet) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `events?id=${id}&limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getEventsCountById = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `events/count?id=${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAllEvents = async (offSet) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `events?limit=10&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getAnalyticsTriggerScript = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `webpageTriggers/defaultScript?webpageTriggerId=${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};
